import type { useI18n } from '../../i18n/index.js';
import type { TranslationKey } from '../../i18n/index.js';
import { billingErrorDetails } from '../../shared/api/billing.js';
import { friendlyError } from '../../shared/api/errors.js';
import { minSec } from './format.js';

type T = ReturnType<typeof useI18n>['t'];

/** "12 min 05 s" — every duration on this screen, one shape. */
export function durationText(t: T, seconds: number): string {
  const { minutes, seconds: s } = minSec(seconds);
  return t('prepaid.duration', { minutes, seconds: String(s).padStart(2, '0') });
}

/** An owner-facing message for a billing callable error: the server's safe
 *  `details.code` when there is one, the generic mapping otherwise. */
export function billingError(t: T, error: unknown): string {
  const { code } = billingErrorDetails(error);
  if (code) return t(`prepaid.error.${code}` as TranslationKey);
  return friendlyError(t, error);
}

